// extracted by mini-css-extract-plugin
module.exports = {"typo":"Typography_typo__2EmKW","left":"Typography_left__2O4cl","right":"Typography_right__3x8gn","center":"Typography_center__PvmYs"};